import { useState } from 'react';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { Card, Typography, Image, CardContent, Box, Dialog } from '@packages/shared';
import { useCookieConsent } from '@packages/utilities';
import { useIntl } from 'react-intl';
import { LoadBeeCardMessages } from './messages';

const LoadbeeFragment = graphql(/* GraphQL */ `
  fragment LoadbeeFragment on Product {
    brand {
      image
      name
    }
    loadbee(locale: $locale) {
      url
    }
  }
`);

export const LoadbeeCard = ({
  productData,
}: {
  productData: FragmentType<typeof LoadbeeFragment>;
}) => {
  const { brand, loadbee } = getFragmentData(LoadbeeFragment, productData);

  const isAllowed = useCookieConsent('C0004');

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const { formatMessage } = useIntl();

  if (!isAllowed || !loadbee?.url) {
    return null;
  }

  return (
    <Card>
      <CardContent
        onClick={() => setIsModalOpen(true)}
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {brand?.image && (
          <Box
            sx={{
              mr: 2,
            }}
          >
            <Image
              loading="lazy"
              src={brand.image}
              alt={brand.name}
              style={{ objectFit: 'contain' }}
              width={50}
              height={30}
            />
          </Box>
        )}
        <Typography variant="body1">
          {formatMessage(LoadBeeCardMessages.labelText, {
            brand: brand?.name || '',
          })}
        </Typography>
      </CardContent>

      <Dialog
        open={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        size="xl"
        // TOOD: ask UX for fallback headline
        title={formatMessage(LoadBeeCardMessages.modalHeadline, {
          brand: brand?.name || '',
        })}
        dialogContent={<iframe title="title" src={loadbee.url} width="100%" height="100%" />}
        sx={{
          '.MuiDialogContent-root': {
            overflow: 'hidden',
          },
          '.MuiPaper-root': {
            height: '100%',
          },
        }}
      />
    </Card>
  );
};
